import React from 'react';
import useWindowSize from '../../../registered/companyList/search/windowResize';

function Success() {
    const size = useWindowSize();

    return (
        <>
            {size.height >= 400 && <div className="success-extender"></div>}
            
            <div className="success_container">
                <h2>Success!</h2>
                <p>Your request was successfully sent and we have sent a contact to the primary contract person for signing.
                    Please check your inbox for mail from echosign@echosign.com.
                </p>
                <div className="links">
                    <a className="goHome" href="https://magnetjqs.com/">Go to Magnet JQS information</a> {/* home link  */}
                </div>
            </div>
        </>
    );
}

export default Success;